import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { useNewsItem } from '@/api/queries/news';
import { Spinner } from '@/components/ui/Spinner';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { formatDateTime } from '@/utils/date';
import { useLocale } from '@/hooks/useLocale';

export function NewsArticlePage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const item = useNewsItem(id ?? null);
  const { t } = useTranslation();
  const { locale } = useLocale();

  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t('news.title')} />
        {item.isLoading && <Spinner />}
        {item.data && (
          <Card variant="light" padding="md">
            {item.data.image_url && (
              <img
                src={item.data.image_url}
                alt=""
                style={{ borderRadius: 12, marginBottom: 12 }}
              />
            )}
            <h1 style={{ margin: 0 }}>{item.data.title}</h1>
            <div style={{ color: 'var(--color-text-on-light-soft)', fontSize: 14, marginTop: 8 }}>
              {item.data.source_name} · {formatDateTime(item.data.published_at, locale)}
            </div>
            <p style={{ marginTop: 16, whiteSpace: 'pre-wrap' }}>{item.data.body || item.data.snippet}</p>
            <div style={{ marginTop: 12 }}>
              <Button variant="plain" onClick={() => window.open(item.data?.url, '_blank', 'noopener')}>
                {t('news.open_external')}
              </Button>
            </div>
          </Card>
        )}
      </PageContainer>
    </AppShell>
  );
}
